(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("YXTPC"), require("axios"), require("Vue"), require("VueI18n"), require("Vuex"));
	else if(typeof define === 'function' && define.amd)
		define(["YXTPC", "axios", "Vue", "VueI18n", "Vuex"], factory);
	else if(typeof exports === 'object')
		exports["YXTBIZ"] = factory(require("YXTPC"), require("axios"), require("Vue"), require("VueI18n"), require("Vuex"));
	else
		root["YXTBIZ"] = factory(root["YXTPC"], root["axios"], root["Vue"], root["VueI18n"], root["Vuex"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__6__, __WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__35__, __WEBPACK_EXTERNAL_MODULE__43__) {
return 